import { z } from 'zod';

import { DocumentValidatorSchema } from './validators/document';
import { DocumentSizeValidatorSchema } from './validators/document-size';
import { FormatValidatorSchema } from './validators/format';
import { FutureDateValidatorSchema } from './validators/future-date';
import { MaxLengthValidatorSchema } from './validators/max-length';
import { MaximumValidatorSchema } from './validators/maximum';
import { MinLengthValidatorSchema } from './validators/min-length';
import { MinimumValidatorSchema } from './validators/minimum';
import { MinimumAgeValidatorSchema } from './validators/minimum-age';
import { MinimumTimeDistanceValidatorSchema } from './validators/minimum-time-distance';
import { PastDateValidatorSchema } from './validators/past-date';
import { PatternValidatorSchema } from './validators/pattern';
import { RequiredValidatorSchema } from './validators/required';
import { SumValidatorSchema } from './validators/sum';

export const ValidatorSchema = z.discriminatedUnion('type', [
  DocumentValidatorSchema,
  DocumentSizeValidatorSchema,
  FormatValidatorSchema,
  FutureDateValidatorSchema,
  MaximumValidatorSchema,
  MaxLengthValidatorSchema,
  MinimumAgeValidatorSchema,
  MinimumValidatorSchema,
  MinLengthValidatorSchema,
  PastDateValidatorSchema,
  PatternValidatorSchema,
  RequiredValidatorSchema,
  MinimumTimeDistanceValidatorSchema,
  SumValidatorSchema,
]);

export type TValidatorSchema = z.infer<typeof ValidatorSchema>;
